import React from 'react';
import { useI18n } from '../context/i18nContext';

const AppleLoginButton = () => {
  // ============================================
  // HOOKS
  // ============================================
  const { t } = useI18n();

  // ============================================
  // HANDLER: Apple OAuth átirányítás
  // ============================================
  // MEGJEGYZÉS: Apple POST-tal válaszol, nem GET-tel!
  // De az inicial request GET-tel kell
  const handleAppleLogin = () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    window.location.href = `${apiUrl}/auth/apple`;
  };

  // ============================================
  // RENDER
  // ============================================
  return (
    <button 
      type="button"
      onClick={handleAppleLogin}
      className="sso-button sso-button-apple"
      title={t('sso.loginWith')}
    >
      {/* APPLE IKON */}
      <svg 
        className="sso-icon" 
        viewBox="0 0 24 24" 
        width="20" 
        height="20"
        fill="currentColor"
      >
        {/* Apple ikon */}
        <path 
          d="M17.05 20.28c-.98.95-2.05.8-3.08.38-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.38C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.48-2.52 3.09l-.04.01z" 
          fill="currentColor"
        />
        <path 
          d="M12.03 7.25c-.15-1.65.93-3.02 2.69-3.02.13 1.73-1.38 2.74-2.69 3.02z" 
          fill="currentColor"
        />
      </svg>
      <span>{t('sso.apple')}</span>
    </button>
  );
};

export default AppleLoginButton;